export const printAreaLayerDefinition = {
    geometryType: 'esriGeometryPolygon',
    objectIdField: 'uniqueId',
    extent: {
        xmin: 93.60870361299999,
        ymin: -54.20349121100003,
        xmax: 139.56890869100005,
        ymax: 24.052603350000027,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            domain: null,
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            domain: null,
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeSmallInteger',
            alias: 'type',
            domain: null,
            editable: true,
            nullable: false
        },
        {
            name: 'name',
            type: 'esriFieldTypeString',
            alias: 'name',
            length: 50,
            nullable: true
        },
        {
            name: 'papersize',
            type: 'esriFieldTypeSmallInteger',
            alias: 'papersize',
            domain: null,
            editable: true,
            nullable: false
        },
        {
            name: 'scale',
            type: 'esriFieldTypeSmallInteger',
            alias: 'scale',
            domain: null,
            editable: true,
            nullable: false
        }
    ]
};
